import { render, staticRenderFns } from "./impact-details.vue?vue&type=template&id=2b58489d&scoped=true&"
import script from "./impact-details.vue?vue&type=script&lang=js&"
export * from "./impact-details.vue?vue&type=script&lang=js&"
import style0 from "./impact-details.vue?vue&type=style&index=0&id=2b58489d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58489d",
  null
  
)

export default component.exports